import React, { Component, CSSProperties } from 'react';

import { supabase } from '../supabaseClient';

// empty comment2
type MyProps = {
  session: any;
};

async function makeCommand(commandType: string) {
  const updates = {
    created_at: new Date(),
    command: { command: commandType },
  };

  await supabase.from('controls').update(updates).eq('id', 1);
}
interface RobotControllerState {
  pressedButton: string | null;
}

class Controls extends Component<MyProps, RobotControllerState> {
  constructor(props: MyProps) {
    super(props);
    this.state = {
      pressedButton: null,
    };
  }

  handleButtonPress = (buttonName: string) => {
    this.setState({ pressedButton: buttonName });
    console.log(buttonName);
    makeCommand(buttonName.toLowerCase());
  };

  handleButtonRelease = () => {
    this.setState({ pressedButton: null });
    console.log('released');
    makeCommand('stop');
  };

  handleContextMenu = (
    event:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.TouchEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  render() {
    const containerStyle: CSSProperties = {
      padding: '20px',
      backgroundColor: 'transparent',
    };

    const clusterStyle: CSSProperties = {
      display: 'grid',
      gridTemplateRows: '1fr 1fr 1fr',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridGap: '10px',
      width: '300px',
      margin: '0 auto',
    };

    const buttonStyle: CSSProperties = {
      backgroundColor: '#4CAF50',
      border: 'none',
      color: 'white',
      textAlign: 'center',
      textDecoration: 'none',
      display: 'inline-block',
      fontSize: '16px',
      padding: '10px 24px',
      borderRadius: '4px',
      width: '100%',
      height: '60px',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none',
      touchAction: 'manipulation',
    };

    const pressedButtonStyle: CSSProperties = {
      ...buttonStyle,
      backgroundColor: '#216e2c',
    };

    // const armButtonStyle: CSSProperties = {
    //   ...buttonStyle,
    //   margin: '10px',
    // };

    // const armPressedButtonStyle: CSSProperties = {
    //   ...armButtonStyle,
    //   backgroundColor: '#216e2c',
    // };

    const buttonTextStyle: CSSProperties = {
      pointerEvents: 'none',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none',
    };

    return (
      <div style={containerStyle}>
        <div style={clusterStyle}>
          <div></div>
          <button
            style={
              this.state.pressedButton === 'forward'
                ? pressedButtonStyle
                : buttonStyle
            }
            onTouchStart={(e) => {
              e.preventDefault();
              this.handleButtonPress('forward');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              this.handleButtonRelease();
            }}
            onTouchMove={(e) => e.preventDefault()}
            onTouchCancel={(e) => e.preventDefault()}
            onPointerDown={() => this.handleButtonPress('forward')}
            onPointerUp={this.handleButtonRelease}
            onContextMenu={this.handleContextMenu}
          >
            <div style={buttonTextStyle}>Forward</div>
          </button>
          <div></div>
          <button
            style={
              this.state.pressedButton === 'left'
                ? pressedButtonStyle
                : buttonStyle
            }
            onTouchStart={(e) => {
              e.preventDefault();
              this.handleButtonPress('left');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              this.handleButtonRelease();
            }}
            onTouchMove={(e) => e.preventDefault()}
            onTouchCancel={(e) => e.preventDefault()}
            onPointerDown={() => this.handleButtonPress('left')}
            onPointerUp={this.handleButtonRelease}
            onContextMenu={this.handleContextMenu}
          >
            <div style={buttonTextStyle}>Left</div>
          </button>
          <button
            style={
              this.state.pressedButton === 'stop'
                ? pressedButtonStyle
                : buttonStyle
            }
            onTouchStart={(e) => {
              e.preventDefault();
              this.handleButtonPress('stop');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              this.handleButtonRelease();
            }}
            onTouchMove={(e) => e.preventDefault()}
            onTouchCancel={(e) => e.preventDefault()}
            onPointerDown={() => this.handleButtonPress('stop')}
            onPointerUp={this.handleButtonRelease}
            onContextMenu={this.handleContextMenu}
          >
            <div style={buttonTextStyle}>Stop</div>
          </button>
          <button
            style={
              this.state.pressedButton === 'right'
                ? pressedButtonStyle
                : buttonStyle
            }
            onTouchStart={(e) => {
              e.preventDefault();
              this.handleButtonPress('right');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              this.handleButtonRelease();
            }}
            onTouchMove={(e) => e.preventDefault()}
            onTouchCancel={(e) => e.preventDefault()}
            onPointerDown={() => this.handleButtonPress('right')}
            onPointerUp={this.handleButtonRelease}
            onContextMenu={this.handleContextMenu}
          >
            <div style={buttonTextStyle}>Right</div>
          </button>
          <div></div>
          <button
            style={
              this.state.pressedButton === 'backward'
                ? pressedButtonStyle
                : buttonStyle
            }
            onTouchStart={(e) => {
              e.preventDefault();
              this.handleButtonPress('backward');
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              this.handleButtonRelease();
            }}
            onTouchMove={(e) => e.preventDefault()}
            onTouchCancel={(e) => e.preventDefault()}
            onPointerDown={() => this.handleButtonPress('backward')}
            onPointerUp={this.handleButtonRelease}
            onContextMenu={this.handleContextMenu}
          >
            <div style={buttonTextStyle}>Backward</div>
          </button>
          <div></div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px',
          }}
        >
          {/* <button
            style={
              this.state.pressedButton === 'extend'
                ? armPressedButtonStyle
                : armButtonStyle
            }
            onTouchStart={() => this.handleButtonPress('extend')}
            onTouchEnd={this.handleButtonRelease}
            onPointerDown={() => this.handleButtonPress('extend')}
            onPointerUp={this.handleButtonRelease}
            onContextMenu={this.handleContextMenu}
          >
            Retract
          </button>
          <button
            style={
              this.state.pressedButton === 'retract'
                ? armPressedButtonStyle
                : armButtonStyle
            }
            onTouchStart={() => this.handleButtonPress('retract')}
            onTouchEnd={this.handleButtonRelease}
            onPointerDown={() => this.handleButtonPress('retract')}
            onPointerUp={this.handleButtonRelease}
            onContextMenu={this.handleContextMenu}
          >
            Extend
          </button> */}
        </div>
      </div>
    );
  }
}
export default Controls;
